import { gql, TypedDocumentNode, useQuery } from '@apollo/client';
import { Alert, AlertColor, AlertProps, AlertTitle, SxProps } from '@mui/material';
import React, { useMemo } from 'react';
import { backendResponse } from '../types/backendResponse';

const GET_SPECIAL_INSTRUCTION: TypedDocumentNode<
  {
    getSpecialInstruction: backendResponse<{
      pathName: string;
      title?: string;
      body?: string;
      severity?: string;
    }>;
  },
  {
    pathName: string;
  }
> = gql`
  query GetSpecialInstruction($pathName: String!) {
    getSpecialInstruction(pathName: $pathName) {
      success
      error
      data {
        pathName
        title
        body
        severity
      }
    }
  }
`;

export const SpecialInstruction: React.FC<{
  pathName: string;
  alertProps?: Partial<AlertProps>;
  sx?: SxProps;
  /**
   * @deprecated for debugging purposes only. Do not commit code that turns this option on.
   */
  debugMode?: boolean;
}> = ({ pathName, alertProps, sx, debugMode }) => {
  // allow silent failure.
  // failure means that there is no instruction that should be displayed.
  const { data, loading } = useQuery(GET_SPECIAL_INSTRUCTION, {
    variables: {
      pathName,
    },
  });
  console.log(data);

  const { severity, title, body } = useMemo(
    () => ({
      severity: (data?.getSpecialInstruction?.data?.severity as AlertColor) || 'info',
      title:
        data?.getSpecialInstruction?.data?.title || (debugMode ? 'Debug Mode' : null), // parentheses are required
      body:
        data?.getSpecialInstruction?.data?.body ||
        (debugMode
          ? 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
          : null), // parentheses are required
    }),
    [data, debugMode],
  );

  if (loading || !body) return null;
  return (
    <Alert
      severity={severity}
      sx={{
        mb: 2,
        ...sx,
      }}
      {...alertProps}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {body}
    </Alert>
  );
};
